import React from "react";
import styles from './styles.module.css';
import cn from 'classnames';
import * as Icon from '../../../components/Icons';
 const Overview = () => {
 	return (
 		<div>
		    <div className={cn([styles.flexContainer,styles.spaceBetween])}>
			    <div>
					<p className={styles.title}>Kandima Maldives</p>
			    </div>
			    <div className={styles.flexContainer}>
					<p className={styles.grayText}> 402 rev</p>
				    <p className={styles.rating}>9,2</p>
			    </div>
		    </div>
		    <div className={cn([styles.flexContainer,styles.spaceBetween])}>
			    <div>
				    <p className={styles.star}>&#9734; &#9734; &#9734; &#9734; &#9734;</p>
				    <div>
					    <div className={cn([styles.flexContainer,styles.alignCenter])}>
						    <Icon.MapMarker fill={"var(--color-red)"} style={{fontSize:"2rem"}}/>
						    <p className={styles.grayText}> Adresss</p>
					    </div>
				    </div>
			    </div>
			    <div className={styles.icon}>
					<Icon.Heart fill={"var(--color-primary)"} style={{fontSize:"2rem"}} />
			    </div>
		    </div>
	    </div>

    )
 };
 export default Overview